import { render, staticRenderFns } from "./pushservice.vue?vue&type=template&id=671c041a&scoped=true&"
import script from "./pushservice.vue?vue&type=script&lang=js&"
export * from "./pushservice.vue?vue&type=script&lang=js&"
import style0 from "./pushservice.vue?vue&type=style&index=0&id=671c041a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671c041a",
  null
  
)

export default component.exports